<template>
  <div class="container container--employee employee-orders-catalog">
    <div class="row no-gutters">
      <div class="col-sm-auto">
        <router-link
          :to="{ name: routeName, params: { auctionType: $route.params.auctionType } }"
          class="submit-btn dashboard__back link--muted">
          <span class="icon icon-arrow-left btn-oval btn-oval--transparent"></span>
          {{I18n.t('back_button.back_to_auctions_list')}}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'BackToAuctionsCatalogsLink',
    props: {
      routeName: String,
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/employees/components/back_to_auctions_catalogs_link.vue?453c9af4